<template lang="">
  <v-container fluid>
    <v-card color="white" style="margin-top: 40px">
      <v-layout row>
        <v-card flat>
          <v-badge left overlap>
            <template v-slot:badge>
              <v-btn
                round
                color="primary"
                fab
                small
                style="margin-top: -1.3em"
                class="elevation-0"
                v-if="getDataOfinsertSlotList.length > 0"
                >{{ getDataOfinsertSlotList.length }}</v-btn
              >
            </template>
            <v-card-text class="title">Insert Slot List</v-card-text>
          </v-badge>
        </v-card>

        <v-divider class="my-2" vertical></v-divider>
        <v-text-field
          v-model="search"
          prepend-inner-icon="search"
          label="Search by table name"
          class="mt-0"
          hide-details
          solo
          flat
          single-line
        ></v-text-field>
        <v-spacer />

        <v-layout row justify-end>
          <v-dialog v-model="dialog" persistent max-width="900px">
            <template v-slot:activator="{ on }">
              <v-btn color="#3F51B5" dark v-on="on">
                <v-icon size="30" color="#fff">add</v-icon>
                <p style="margin-top: 20px; color: #fff">Insert</p>
              </v-btn>
            </template>
            <v-card>
              <v-card-title style="background-color:#3F51B5; color:#fff;">
                <span class="headline">Insert FF Data</span>
                <v-spacer></v-spacer>
                <v-btn small fab dark color="red" @click="closeDia()"
                  ><v-icon size="22" color="#fff">close</v-icon></v-btn
                >
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-form>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md12>
                        <v-text-field
                          label="Table Name"
                          v-model="searchParam.table_name"
                          v-validate="'required'"
                          prepend-icon="edit"
                          outline
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          label="Installment No"
                          v-model="searchParam.inst"
                          type="number"
                          required
                          prepend-icon="edit"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6>
                        <v-select
                          :items="['formfillup', 'probable']"
                          v-model="searchParam.data_type"
                          label="Data Type"
                          prepend-icon="list"
                          required
                        ></v-select>
                      </v-flex>

                      <v-flex xs6 md6 sm6 style="padding-left: 37px;">
                        <v-checkbox
                          v-model="need_incourse_before_ff"
                          :label="`Need Incourse Before Form Fill-up`"
                        ></v-checkbox>

                        <v-checkbox
                          v-model="remove_and_update_not_applied"
                          :label="`Remove & Update Not Applied`"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs6 md6 sm6 style="padding-left: 37px;">
                        <v-checkbox
                          v-model="remove_and_update_not_confirmed"
                          :label="`Remove & Update Not Confirmed`"
                        ></v-checkbox>

                        <v-checkbox
                          v-model="update_pl_on_remove_or_cancel"
                          :label="`Update PL On Remove Or Cancel`"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
                <small
                  style="font-size:14px; color:#df1515; padding-left: 51px;"
                  >*N:B: The table name must contains:
                  REG_NO,DEG_CODE,SUB_CODE,STD_TYPE,COL_CODE,SIF,IMP_ALL,OPT_ALL,ELECT_ALL,PREV_Y_RES,RUN_Y_RES,INC_STATUS,INC_MARKS</small
                >
                <v-layout v-if="errors_data != ''">
                  <v-flex xs12 sm3></v-flex>
                  <v-flex xs12 sm6>
                    <v-card
                      style="background-color:red; padding:20px; color:#fff; margin-top:10px;"
                    >
                      {{ errors_data }}
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm3> </v-flex>
                </v-layout>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  style="margin-bottom:10px;"
                  dark
                  color="#3F51B5"
                  @click="saveffinsert()"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <v-btn small fab @click="getDataOfinsertSlotSet()">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-layout>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="getDataOfinsertSlotList"
      class="elevation-1"
      :total-items="pagination.total"
      :pagination.sync="pagination"
      :loading="loading"
      :rows-per-page-items="[50, 100, 500]"
    >
      <template v-slot:items="props">
        <!-- <td class="text-xs-center">{{ props.index + 1 }}</td> -->
        <td class="text-xs-center">
          {{ props.item.installment }}
        </td>
        <td class="text-xs-center">
          {{ props.item.table_name }}
        </td>
        <td class="text-xs-center">
          <span>
            {{ props.item.total_students }}
          </span>
        </td>
        <td class="text-xs-center">
          <span>
            {{ props.item.total_inserted }}
          </span>
        </td>
        <td class="text-xs-left">{{ props.item.added_by }}</td>
        <td class="text-xs-center">
          <span>
            {{ props.item.added_on }}
          </span>
        </td>
        <td class="text-xs-center">
          <span>
            {{ props.item.remarks }}
          </span>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import commonGet from "../../mixin/common_getters_mixin";
import commonExamYear from "../../mixin/exam_year_watch_mixin";
import common_login_getters from "../../mixin/common_login_getters";

export default {
  mixins: [commonGet, commonExamYear, common_login_getters],

  data() {
    return {
      need_incourse_before_ff: false,
      remove_and_update_not_applied: false,
      remove_and_update_not_confirmed: false,
      update_pl_on_remove_or_cancel: false,
      errors_data: "",
      success_data: "",
      dialog: false,
      searchParam: {},
      loading: false,
      pagination: {
        ascending: true,
        rowsPerPage: 50,
      },
      headers: [
        { text: "Installment", value: "installment", align: "left" },
        { text: "Table Name", value: "table_name", align: "left" },
        { text: "Total Students", value: "total_students", align: "left" },
        { text: "Total Inserted", value: "total_inserted", align: "left" },
        { text: "Added By", value: "added_by", align: "left" },
        { text: "Added On", value: "added_on", align: "left" },
        { text: "Remarks", value: "remarks", align: "left" },
      ],
      validationErrors: {},
      search: "",
    };
  },

  created() {
    // this.getDataOfinsertSlotSet();
  },

  computed: {
    getDataOfinsertSlotList() {
      return this.$store.getters.dataOfinsertSlotList;
    },
  },

  watch: {
    pagination() {
      this.getDataOfinsertSlotSet();
    },
    search: function(newQuery) {
      this.getDataOfinsertSlotSet(newQuery); // Call the debounced function
    },
  },

  methods: {
    setLimit() {
      const { sortBy, page, rowsPerPage } = this.pagination;
      this.searchParam.page = page;
      this.searchParam.limit = rowsPerPage;
      this.searchParam.sort = sortBy;
      this.searchParam.search = this.search;
      this.searchParam.exam_code = this.getLoggedInExam.code;
      this.searchParam.year = this.getLoggedInYear.year;
    },

    getDataOfinsertSlotSet() {
      this.setLimit();
      this.loading = true;
      this.$store
        .dispatch("fetchinsertSlotData", this.searchParam)
        .then((data) => {
          // console.log("data.meta.total", data);
          this.loading = false;
          this.pagination.totalItems = data.meta.total;
        });
    },

    closeDia() {
      this.searchParam.table_name = "";
      this.searchParam.inst = "";
      this.searchParam.data_type = "";
      this.dialog = false;
      this.errors_data = "";
    },

    saveffinsert() {
      if (
        !this.searchParam.table_name ||
        !this.searchParam.inst ||
        !this.searchParam.data_type
      ) {
        this.errors_data = "";
        this.errors_data = "All fields are required!";
        return;
      } else {
        const payload = {
          table_name: this.searchParam.table_name,
          inst: this.searchParam.inst,
          data_type: this.searchParam.data_type,
          exam_code: this.getLoggedInExam.code,
          exam_year: this.getLoggedInYear.year,
          need_incourse_before_ff: this.need_incourse_before_ff ? 1 : 0,
          remove_and_update_not_applied: this.remove_and_update_not_applied ? 1 : 0,
          remove_and_update_not_confirmed: this.remove_and_update_not_confirmed ? 1 : 0,
          update_pl_on_remove_or_cancel: this.update_pl_on_remove_or_cancel ? 1 : 0,
        };
        this.$store
          .dispatch("storeffSlotData", payload)
          .then((rsp) => {
            console.log("Tanvir! This is pay load", rsp);
            this.getDataOfinsertSlotSet();
            this.closeDia();
          })
          .catch((error) => {
            console.error("🔥 storeffSlotData error:", error);
            this.errors_data = error;
          });
      }
    },
  },
};
</script>
<style></style>
